import React, { useEffect, useState } from "react";
import Panchayath from "../components/Panchayath";
import Assembly from "../components/Assembly";
import Bhooth from "../components/Bhooth";
import Constituency from "../components/Constituency";
import Dashboard from "../components/DashboardCards/Group";
import GrievanceList from "./GrivenceList";
import dataService from "../networks/api/service/dataService";

function Home() {
  const role = localStorage.getItem("UserRole");

  // State to store fetched data
  const [dashboardData, setDashboardData] = useState({
    data: [],
    grievanceList: [],
    assignedGrievance: [],
  });

  // Function to fetch API data
  const fetchDashboardData = async () => {
    try {
      const res = await dataService.constituencyDashboard(); // Fetch data
      setDashboardData({
        data: res?.data || [],
        grievanceList: res?.data?.grievanceList || [],
        assignedGrievance: res?.data?.assignedGrievance || [],
      });
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    }
  };

  // Fetch data when component mounts
  useEffect(() => {
    fetchDashboardData();
  }, []);



  return (
    <div>

      <Dashboard
     data={dashboardData.data}
      grievanceList={dashboardData.grievanceList}
      assignedGrievance={dashboardData.assignedGrievance}
      />
      {/* {role === "PANCHAYAT" ? (
        <Panchayath />
      ) : role === "ASSEMBLY" ? (
        <Assembly />
      ) : role === "BOOTH" ? (
        <BoothDetails />
      ) : role === "CONSTITUENCY" ? (
        <Constituency />
      ) : null} */}
    </div>
  );
}

export default Home;
